import { down } from 'styled-breakpoints'
import styled from 'styled-components'

export const SliderContainer = styled.section<{ padding: number }>`
  width: 100%;
  max-width: 1180px;
  margin: 0 auto;

  .splide__track {
    padding-top: 30px;
    padding-bottom: 30px;
    margin-top: -30px;
    margin-bottom: -30px;

    margin-left: ${(p) => (p.padding ? `-${p.padding + 2}px` : undefined)};
    margin-right: ${(p) => (p.padding ? `-${p.padding + 2}px` : undefined)};
  }

  .splide__pagination {
    position: relative;
    bottom: 0;
    padding: 16px 1em 0 1em;

    .splide__pagination__page {
      background-color: #d7dddb;
      opacity: 0.4;
      width: 10px;
      height: 10px;
    }

    .splide__pagination__page.is-active {
      background-color: #c2cac8;
      opacity: 1;
      transform: none;
    }
  }

  .splide--rtl {
    [dir='rtl'] & {
      position: relative;
    }
  }

  /* LTR için default pozisyonlar */
  .splide__arrow--prev {
    left: -22px !important;
    right: auto !important;
  }

  .splide__arrow--next {
    right: -22px !important;
    left: auto !important;
  }

  /* RTL support - arrow'ların pozisyonlarını tersine çevir */
  .splide--rtl {
    .splide__arrow--prev {
      left: auto !important;
      right: -22px !important;
    }

    .splide__arrow--next {
      right: auto !important;
      left: -22px !important;
    }
  }

  ${down('md')} {
    margin: 0 auto;
    max-width: 98%;
  }
`
